import { render } from "./LabelFilterSidebarHeader.vue?vue&type=template&id=c9c6885c&scoped=true&ts=true"
import script from "./LabelFilterSidebarHeader.vue?vue&type=script&lang=ts"
export * from "./LabelFilterSidebarHeader.vue?vue&type=script&lang=ts"

import "./LabelFilterSidebarHeader.vue?vue&type=style&index=0&id=c9c6885c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9c6885c"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QSpace,QTooltip});
